import { FC } from 'react';

import { YbConfirmDialogue } from '@yubi/yb-core-modal-v3';
import { ConfirmationDialogueProps } from '@yubi/yb-core-modal-v3/dist/dts/YbCoreModal.types';

const ConfirmModal: FC<ConfirmationDialogueProps> = ({
  showCloseIcon = true,
  ...props
}) => {
  return <YbConfirmDialogue {...props} showCloseIcon={showCloseIcon} />;
};

export default ConfirmModal;
